import script from "./ChooseTaxAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChooseTaxAccount.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__